import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';

/**
 * Builds a breadcrumb trail that always starts with the Bridebook home crumb, followed by the
 * given parent items and an optional trailing crumb for the current page.
 */
export const getBreadcrumbsWithHome = (
  name: string | undefined,
  parentItems: Array<IBreadcrumbItem> = [],
): Array<IBreadcrumbItem> => {
  const breadcrumbsData = [{ name: 'Bridebook', path: '/', id: 'home' }, ...parentItems];
  if (name) {
    breadcrumbsData.push({ name, id: 'name' });
  }
  return breadcrumbsData;
};
